import axios from 'axios';
import { toast } from 'react-toastify';
import { isInfrastructureError } from 'utils/apiErrors';

export function resolveRuntimeUrl(url) {
  if (!url || typeof window === 'undefined') {
    return url;
  }

  try {
    const resolvedUrl = new URL(url, window.location.origin);
    const browserHost = window.location.hostname;
    const isLocalHost = ['localhost', '127.0.0.1'].includes(resolvedUrl.hostname);
    const isBrowserLocalHost = ['localhost', '127.0.0.1'].includes(browserHost);

    if (isLocalHost && isBrowserLocalHost) {
      resolvedUrl.hostname = browserHost;
    }

    return resolvedUrl.toString().replace(/\/$/, '');
  } catch {
    return url;
  }
}

const api = axios.create({
  baseURL: resolveRuntimeUrl(process.env.REACT_APP_API_URL),
});

let isRedirecting = false;

const AUTH_ROUTES = ['/paciente/login', 'msessions', 'fsessions', 'funcsignup'];

function isAuthRequest(error) {
  const url = error.config?.url ?? '';
  return AUTH_ROUTES.some((route) => url.includes(route));
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && typeof error === 'object') {
      error.isInfrastructureError = isInfrastructureError(error);
    }
    const status = error.response?.status;

    // 401 em login/signup = credenciais inválidas; não tratar como sessão expirada
    if (status === 401 && !isAuthRequest(error) && !isRedirecting) {
      isRedirecting = true;

      try {
        localStorage.removeItem('persist:prevencor-localDB');
        sessionStorage.removeItem('prevencor_tab_session_active');
      } catch {
        // ignora erros de storage bloqueado
      }

      delete api.defaults.headers.Authorization;
      delete api.defaults.headers['x-user-id'];
      delete api.defaults.headers['x-user-nome'];
      delete api.defaults.headers['x-user-role'];

      const redirectToHome = () => {
        if (typeof window !== 'undefined') {
          window.location.replace('/');
        }
      };

      const fallbackTimer = setTimeout(redirectToHome, 2200);

      // Exibe o Toast e garante redirecionamento mesmo que a guia esteja em background
      toast.warn('Sua sessão expirou. Redirecionando...', {
        toastId: 'session-expired',
        autoClose: 2000,
        pauseOnHover: false,
        onClose: () => {
          clearTimeout(fallbackTimer);
          redirectToHome();
        },
      });

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
